<template>
  <div
    class="result-patient-item"
    :class="{
      selected: selected,
      expanded: expanded,
      is_group: patient.isGroup,
      is_child: patient.isChild,
      is_empty: !patient.isGroup && !patient.isChild,
    }"
  >
    <div class="patient-wrapper" @click="onItemClick">
      <div class="upper-info">
        <div class="patient-name">
          <div class="fake-checkbox-container">
            <input
              class="checkbox"
              type="checkbox"
              :checked="isChecked"
              :indeterminate.prop="isIndeterminate"
              @change="onMainCheckbox"
              @click.stop
            />
            <div class="fake-checkbox"></div>
          </div>
          <div class="text">{{ itemLabel || "..." }}</div>
        </div>
        <div class="patient-conditions">
          <template v-if="!patient.isChild">
            <cohort-fields
              :patient="patient"
              :include="['gender']"
            ></cohort-fields>
          </template>
          <template v-if="!patient.isGroup">
            <cohort-fields
              :patient="patient"
              :exclude="['gender']"
            ></cohort-fields>
          </template>
        </div>
      </div>
      <div class="lower-info">
        <div v-if="patient.sparkline" class="patient-ecgs">
          <div
            class="mini-ecg-container"
            v-for="(ecg, ecgIndex) in ecgCharts"
            :key="'ecg-' + patient.id + '-' + ecgIndex"
          >
            <span class="mini-ecg-title">{{ ecg.key }}</span>
            <mini-ecg :data="ecg.data" :showTooltip="true" :units="ecg.units"></mini-ecg>
          </div>
        </div>
        <div class="patient-global-values">
          <div v-if="patient.isGroup && patientContainsArrythmicCase" class="alert-icon"></div>
          <div class="patient-value-info" v-if="patient.isGroup && globalValues.length > 0">Mean ± SD</div>
          <div
            class="patient-value-item"
            :class="{group: patient.isGroup}"
            v-for="res in globalValues"
            :key="res.label"
          >
            <span class="patient-value-label">{{ res.label }}</span>
            <span class="patient-value">{{ res.value }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="patient.cases"
        :class="['toggle-button', { open: expanded }]"
      ></div>
      <div
        v-if="!this.patient.isGroup"
        class="action btn btn--primary"
        @click="onActionClick"
      >
        Expand Case
      </div>
    </div>
    <transition-expand name="slide">
      <div v-if="expanded" class="children">
        <result-patients-list-item
          v-for="_case in patient.cases"
          :patient="_case"
          :key="_case.id"
          :selected="selectedChildren && (selectedChildren.indexOf(_case) >= 0)"
          @selectToggle="$emit('selectToggle', _case)"
          labelAttr="trialId"
          labelExpr="%s"
        ></result-patients-list-item>
      </div>
    </transition-expand>
  </div>
</template>

<script>
import MiniEcg from '@/components/CaseDashboard/MiniEcg'
import {TransitionExpand} from 'vue-transition-expand'
import 'vue-transition-expand/dist/vue-transition-expand.css'
import CohortFields from '@/components/commons/CohortFields'
import Api from '@/api'

export default {
  name: 'ResultPatientsListItem',
  props: {
    // execution: Object,
    patient: Object,
    selected: Boolean,
    selectedChildren: Array,
    expanded: Boolean,
    labelAttr: {default:'subjectId'},
    labelExpr: {default:'Subject %s'}
  },
  components: {MiniEcg, TransitionExpand, CohortFields},
  asyncComputed:{
    itemLabel(){
      if(this.labelAttr==='trialId'){
        return this.patient.trialMeta.name
      } else if(this.labelAttr==='subjectId'){ 
        return this.labelExpr.replace('%s',this.patient.subject.templateId)
      }else {
        return this.labelExpr.replace('%s',this.patient.subject[this.labelAttr])
      }
    }
  },
  computed: {
    patientContainsArrythmicCase () {
      return this.patient ? this.patient.cases.some(c => c.scalars.some(s => s.value == null)) : false
    },
    projectId() {
      return this.$route.params.project
    },
    // itemLabel(){
    //   return this.labelExpr.replace('%s',this.patient[this.labelAttr])
    // },
    globalValues () {
      return this.patient.scalars ? this.patient.scalars.map(e => {
        if (e.value != null) {
          return {
            label: e.name,
            value: e.mean ? Number.parseFloat(e.mean).toFixed(2)+' ± '+Number.parseFloat(e.std).toFixed(2) : e.value.toFixed(2)
          }
        } else {
          return {
            label: e.name,
            value: '-'
          }
        }
      }) : []
    },
    //globalValues () {
    //   return this.patient.scalars.map(e => {
    //     return {
    //       label: e.name,
    //       //WANRING FALTA TODO LO DEL "MEAN"
    //       value: e.value.toFixed(3)
    //     }
    //   })
    // },
    ecgCharts () {
      let ecgData = []
      let headers = this.patient.sparkline.headers
      let timeIndex = Math.max(headers.indexOf('T'), 0) // Avoid -1 if no 't' header is found
      headers.forEach((head, headIndex) => {
        if (headIndex != timeIndex) {
          ecgData.push({
            key: head,
            data: this.patient.sparkline.rows.map(row => {
              return {
                t: row[timeIndex],
                value: row[headIndex]
              }
            }),
            units: {x:this.patient.sparkline.units[timeIndex],y:this.patient.sparkline.units[headIndex]}
          })
        }
      })
      return ecgData
    },
    isChecked () {
      if(this.patient.cases) return this.selectedChildren && this.selectedChildren.length === this.patient.cases.length
      else return this.selected
    },
    isIndeterminate () {
      return this.selectedChildren && this.selectedChildren.length>0 && this.selectedChildren.length<this.patient.cases.length
    }
  },
  methods: {
    onItemClick () {
      if(this.patient.isGroup) this.$emit('expand')
      else this.$emit('selectToggle',this.patient)
    },
    onActionClick () {
      this.goToResultDashboard()
    },
    onMainCheckbox (e) {
      if(!this.patient.isGroup) {
        this.$emit('selectToggle',this.patient)
      } else {
        // this.patient.cases.forEach((c)=>{
        //   this.$emit('selectToggle',c,e.target.checked)
        // })
        this.$emit('selectToggle',this.patient.cases,e.target.checked)
      }
    },
    goToResultDashboard() {
      this.$store.state.trialToShowInResultsCrumb = `trial#${this.patient.trialId}`
      this.$router.push({path: `/project/${this.projectId}/results/trial/${this.patient.trialId}/subject/${this.patient.subject.templateId}`})
    }
  }
}
</script>

<style lang="stylus" scoped>
.result-patient-item
  &.is_empty
    background-color: #fff
    cursor: pointer

    &:not(:last-child)
      margin-bottom: 1px

    .patient-wrapper
      height: 60px

    .upper-info
      align-items: flex-start
      flex-direction: column

    .lower-info
      align-items: flex-end
      flex-direction: column

    .patient-conditions
      margin-left: 25px

  &.is_group
    background-color: #fff
    cursor: pointer

    &:not(:last-child)
      margin-bottom: 1px

  &.is_child
    background-color: transparent
    cursor: default

    &:not(:last-child)
      border-bottom: 1px solid #fff

    .patient-wrapper
      height: 60px
      margin-left 30px

    .upper-info
      align-items: flex-start
      flex-direction: column

    .lower-info
      align-items: flex-end
      flex-direction: column

    .patient-conditions
      margin-left: 25px

.patient-wrapper
  align-items: center
  display: flex
  height: 40px
  padding: 0 20px

.upper-info
  align-items: center
  display: flex
  flex: 1 1 0%
  white-space: nowrap

.patient-name
  align-items: center
  display: flex
  height: 30px

  .fake-checkbox-container
    margin-right: 10px
    position: relative

  .checkbox
    left: 50%
    margin: 0
    opacity: 0
    position: absolute
    top: 50%
    transform: translate(-50%, -50%)

    &:checked
      + .fake-checkbox
        m-icon("checkbox-checked", 16)

    &:indeterminate
      + .fake-checkbox
        m-icon("checkbox-indeterminate", 16)

  .fake-checkbox
    m-icon("checkbox", 16)

.patient-ecgs
  align-items: center
  display: flex
  height: 30px

.mini-ecg-container
  align-items: center
  display: flex

  // flex: 0 0 200px
  // margin-left: 30px
  // position: relative
  &:not(:last-child)
    margin-right: 20px

.mini-ecg-title
  color: $cloud-burst
  m-font-size(12, 14)
  margin-right: 10px
  opacity: 0.5

.mini-ecg
  height: 20px
  // margin-left: 20px
  max-width: 150px
  position: relative
  width: 150px

.toggle-button
  margin-left: 40px
  m-icon("toggle-panel-caret", 20)
  cursor: pointer
  transform: rotate(0)
  transition: all 0.25s ease-in-out

  &.open
    transform: rotate(180deg)

.lower-info
  align-items: center
  display: flex
  overflow-x: auto
  overflow-y: hidden
  height: 100%
  // margin-left: auto
  // padding: 0 10px

.patient-conditions
  display: flex
  margin-left: 15px
  .cohort-fields
    display flex

.patient-global-values
  display: flex
  margin-left: auto

.alert-icon
  m-icon("alert", 18)
  cursor: pointer
  margin-right: 10px

.patient-value-info
  m-font-size(10, 11)
  color: #9CA8B4
  margin-right: 8px
  border-right 1px solid #9CA8B4
  padding-right 8px
  align-items: center
  display: flex
  white-space: nowrap

.patient-value-item
  align-items: center
  display: flex
  margin-right: 10px
  min-width 60px
  &.group
    min-width 110px

.patient-value-label
  m-font-size(10, 11)
  color: #9CA8B4
  margin-right: 4px

.patient-value
  m-font-size(14, 16)
  color: #32343B

.action
  margin-left: 40px

// color: #e46
// cursor: pointer

// &:hover
// text-decoration: underline
.children
  background-color: $mystic

  // overriding vue-transition-expand.css :(
  &.expand-enter-active,
  &.expand-leave-active
    transition-duration: 0.25s
</style>